/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import FormField from '../../../../client/js/components/form/fields/FormField'
import { getPermissions } from '../../../permission/lib/permissionAPIClient'
import { useQuery } from '@tanstack/react-query'
import { getHalEmbedded } from '@jalik/hal'
import { parseNumber } from '@jalik/form-parser'
import { Checkbox, Loader, SimpleGrid } from '@mantine/core'

function PermissionsField () {
  const permissionsQuery = useQuery({
    enabled: true,
    queryKey: ['permissions'],
    queryFn: () => getPermissions({ limit: 100 })
  })
  const permissions = useMemo(() => (
    (permissionsQuery.data != null ? getHalEmbedded(permissionsQuery.data)?.permissions : null) || []
  ), [permissionsQuery.data])

  return permissionsQuery.isFetching
    ? <Loader />
    : <SimpleGrid cols={{ sm: 2, lg: 4 }}>
      {permissions.map((permission) => (
        <FormField
          key={permission.id}
          label={permission.slug}
          name="permissions"
          parser={parseNumber}
          render={Checkbox}
          type="checkbox"
          value={String(permission.id)}
        />
      ))}
    </SimpleGrid>
}

export default PermissionsField
